module.exports = __webpack_public_path__ + "static/img/bg10.cae6588.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg10.jpg
// module id = WmgQ
// module chunks = 1